import {
  SET_CURRENT_USER,
  SELECT_BOAT,
  ADD_BOAT,
  LIST_BOATS,
  BOOKING_CARD,
  SIMILAR_BOATS,
  CHECKOUT_DATA,
  USER_PROFILE,
  CONVERSATION,
  LOCATION,
  AUTH_IS_READY,
  UPDATE_BOAT_RATING,
} from './types';

export const setCurrentUser = (user) => ({
  type: SET_CURRENT_USER,
  payload: user,
});

export const authIsReady = () => ({
  type: AUTH_IS_READY,
});

export const selectBoat = (boat) => {
  return {
    type: SELECT_BOAT,
    payload: boat,
  };
};

export const addBoat = (data) => ({
  type: ADD_BOAT,
  payload: data,
});

export const listBoats = (data) => ({
  type: LIST_BOATS,
  payload: data,
});

export const bookingCard = (fromDate, toDate, bookingDays, price) => ({
  type: BOOKING_CARD,
  payload: { fromDate, toDate, bookingDays, price },
});

export const similarBoats = (data) => ({
  type: SIMILAR_BOATS,
  payload: data,
});

export const checkoutData = (data) => ({
  type: CHECKOUT_DATA,
  payload: data,
});

export const userProfile = (data) => ({
  type: USER_PROFILE,
  payload: data,
});

export const conversation = (data) => ({
  type: CONVERSATION,
  payload: data,
});

export const selectLocation = (data) => ({
  type: LOCATION,
  payload: data,
});

export const updateBoatRatingInStore = (boatState, ratingData) => {
  // The reducer only needs the boat's ID and the new rating data.
  // By extracting only what's needed here, we prevent non-serializable
  // data from the full boatState object from ever entering the action payload.
  return {
    type: UPDATE_BOAT_RATING,
    payload: { boatId: boatState?.uid, ratingData },
  };
};
